module.exports = __webpack_public_path__ + "static/media/add-user.93381c20.jpg";